import { useRef } from 'react';
import { type PickerVariable } from '../definitionEdit.js';
import { TokenField, type TokenFieldHandle } from '../TokenField.js';
import { unknownPaths } from '../tokenText.js';
import { VarPicker } from './VariablePicker.js';

export const TemplateInput = ({
  label,
  value,
  vars,
  source,
  multiline,
  onChange,
}: {
  label: string;
  value: string;
  vars: PickerVariable[];
  source: string | null;
  /** Message bodies want line breaks; titles and inputs stay one line. */
  multiline?: boolean;
  onChange: (v: string) => void;
}) => {
  const field = useRef<TokenFieldHandle | null>(null);
  const stale = unknownPaths(value, vars);
  return (
    // Not a <label>: it would wrap a contenteditable div, which gives the
    // field two accessible names. The caption is text; the field names itself.
    <div className="grid min-w-0 gap-1 text-xs text-ink-muted">
      <span>{label}</span>
      <div className="flex min-w-0 items-start gap-2">
        <TokenField
          label={label}
          value={value}
          vars={vars}
          multiline={multiline}
          onChange={onChange}
          handleRef={field}
        />
        <VarPicker vars={vars} source={source} onPick={(v) => field.current?.insert(v)} />
      </div>
      {stale.length > 0 && (
        <span className="text-[0.68rem] text-danger">
          {stale.length === 1 ? 'One value isn’t' : `${String(stale.length)} values aren’t`}{' '}
          available here any more — replace or remove {stale.length === 1 ? 'it' : 'them'}.
        </span>
      )}
    </div>
  );
};
